import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [CommonModule, A11yModule],
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.scss',
})
export class ConfirmationDialog {
  @Input({required:true}) title = '';
  @Input() message = '';
  @Input() confirmLabel = 'Confirm';
  @Input() busy = false;
  @Input() error = '';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
